import React, { useState } from 'react';
import '../css/Cart.css';
import { useCart } from '../context/CartContext';
import { FaTrash } from 'react-icons/fa';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import InputMask from 'react-input-mask';
import ProductImage from '../components/ProductImage';
import { useNavigate } from 'react-router-dom';
import { BACKEND_URL } from '../config';
import DeliverySelect from '../components/DeliverySelect';

const Checkout = () => {
    const { cartItems, removeFromCart, clearCart } = useCart();
    const safeItems = cartItems || [];
    const [form, setForm] = useState({
        name: '',
        phone: '',
    });
    const [delivery, setDelivery] = useState(null);
    const [payment, setPayment] = useState('cod');
    const [touched, setTouched] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleBlur = (e) => {
        setTouched({ ...touched, [e.target.name]: true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitted(true);
        if (form.name && form.phone && delivery && safeItems.length > 0) {
            const productIds = safeItems.map(item => item.id);
            const quantity = safeItems.reduce((sum, item) => sum + item.quantity, 0);
            const payload = {
                productIds,
                phoneNumber: form.phone,
                userName: form.name,
                quantity,
                delivery,
                payment,
            };
            try {
                const response = await fetch(`${BACKEND_URL}/orders`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                });
                if (!response.ok) {
                    throw new Error('Не вдалося оформити замовлення');
                }
                const data = await response.json();
                clearCart();
                setShowSuccessModal(true);
                if (window.gtag) {
                    const totalValue = safeItems.reduce(
                        (sum, item) => sum + (item.price || 0) * (item.quantity || 1), 0
                    );
                    window.gtag('event', 'purchase', {
                        transaction_id: String(data.id),
                        currency: 'UAH',
                        value: parseFloat(totalValue.toFixed(2)),
                        items: safeItems.map(item => ({
                            item_id: String(item.id),
                            item_name: item.name_ua,
                            price: parseFloat((item.price || 0).toFixed(2)),
                            quantity: item.quantity || 1,
                            google_business_vertical: 'retail',
                        })),
                    });
                }
            } catch (error) {
                alert('Сталася помилка при оформленні замовлення. Спробуйте ще раз.');
            }
        }
    };

    const isNameValid = form.name.trim().length > 0;
    // Перевірка: всі цифри введені (без символів маски)
    const isPhoneValid = /^\+380 \(\d{2}\) \d{3}-\d{2}-\d{2}$/.test(form.phone);
    const isFormComplete = isNameValid && isPhoneValid && !!delivery && safeItems.length > 0;
    const total = safeItems.reduce((sum, item) => sum + item.price * item.quantity, 0);

    return (
        <>
            <Header />
            <SEO
                title="Оформлення замовлення"
                description="Оформити замовлення на автозапчастини в UnionAuto. Швидке оформлення, зручна оплата, доставка по всій Україні."
                canonical="/checkout"
                noindex={true}
            />
            <div className="checkout-page-wrapper" style={{
                maxWidth: 640,
                margin: '40px auto 60px',
                padding: '0 16px',
                boxSizing: 'border-box',
            }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 24, fontWeight: 700 }}>Оформлення замовлення</h2>

                {/* Список товарів */}
                <div style={{
                    border: '1px solid #e5e5e5',
                    borderRadius: 8,
                    marginBottom: 24,
                    overflow: 'hidden',
                }}>
                    <div style={{
                        padding: '14px 20px',
                        borderBottom: '1px solid #e5e5e5',
                        background: '#f9f9f9',
                        fontWeight: 600,
                        fontSize: 15,
                    }}>
                        Товари в замовленні
                    </div>
                    {safeItems.length === 0 ? (
                        <div style={{ padding: 24, color: '#888', textAlign: 'center' }}>Кошик порожній</div>
                    ) : (
                        <>
                            {safeItems.map((item) => (
                                <div key={item.id} style={{
                                    display: 'flex',
                                    gap: 15,
                                    padding: '14px 20px',
                                    borderBottom: '1px solid #f0f0f0',
                                    alignItems: 'center',
                                }}>
                                    <ProductImage src={item.photo} alt={item.name_ua} style={{
                                        width: 64,
                                        height: 64,
                                        objectFit: 'cover',
                                        borderRadius: 4,
                                        flexShrink: 0,
                                    }} />
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontWeight: 500, fontSize: 14, marginBottom: 4 }}>{item.name_ua}</div>
                                        <div style={{ color: '#555', fontSize: 13 }}>Кількість: {item.quantity}</div>
                                    </div>
                                    <div style={{ fontWeight: 600, fontSize: 15, flexShrink: 0 }}>{item.price} грн</div>
                                    <button
                                        onClick={() => removeFromCart(item.id)}
                                        title="Видалити"
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: '#aaa',
                                            padding: 6,
                                            flexShrink: 0,
                                            fontSize: 14,
                                        }}
                                    >
                                        <FaTrash />
                                    </button>
                                </div>
                            ))}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '14px 20px',
                                fontWeight: 700,
                                fontSize: 16,
                                background: '#f9f9f9',
                            }}>
                                <span>Всього:</span>
                                <span>{total.toFixed(2)} грн</span>
                            </div>
                        </>
                    )}
                </div>

                {/* Форма */}
                <div style={{
                    border: '1px solid #e5e5e5',
                    borderRadius: 8,
                    overflow: 'hidden',
                }}>
                    <div style={{
                        padding: '14px 20px',
                        borderBottom: '1px solid #e5e5e5',
                        background: '#f9f9f9',
                        fontWeight: 600,
                        fontSize: 15,
                    }}>
                        Контактні дані та доставка
                    </div>
                    <form onSubmit={handleSubmit} style={{ padding: 20 }}>
                    <div style={{ marginBottom: 15 }}>
                        <label htmlFor="name">Прізвище та ім'я<span style={{ color: 'red' }}> *</span></label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            style={{ width: '100%', padding: 8, marginTop: 5, borderRadius: 4, border: '1px solid #ccc', boxSizing: 'border-box' }}
                        />
                        {((touched.name || submitted) && !isNameValid) && (
                            <div style={{ color: 'red', fontSize: 13 }}>Введіть прізвище та ім'я</div>
                        )}
                    </div>
                    <div style={{ marginBottom: 15 }}>
                        <label htmlFor="phone">Номер телефону<span style={{ color: 'red' }}> *</span></label>
                        <InputMask
                            mask="+380 (99) 999-99-99"
                            maskChar="_"
                            value={form.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        >
                            {(inputProps) => (
                                <input
                                    {...inputProps}
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    required
                                    style={{ width: '100%', padding: 8, marginTop: 5, borderRadius: 4, border: '1px solid #ccc', boxSizing: 'border-box' }}
                                />
                            )}
                        </InputMask>
                        {((touched.phone || submitted) && !isPhoneValid) && (
                            <div style={{ color: 'red', fontSize: 13 }}>Введіть номер телефону у форматі +380 (XX) XXX-XX-XX</div>
                        )}
                    </div>
                    <DeliverySelect
                        value={delivery}
                        onChange={setDelivery}
                        submitted={submitted}
                    />
                    <div style={{ marginBottom: 15, marginTop: 5 }}>
                        <label style={{ fontWeight: 600, display: 'block', marginBottom: 10 }}>
                            Спосіб оплати<span style={{ color: 'red' }}> *</span>
                        </label>
                        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                            {[
                                { id: 'cod', label: 'Накладений платіж', desc: 'Оплата при отриманні на Новій Пошті' },
                                { id: 'transfer', label: 'Оплата за реквізитами', desc: 'Банківський переказ до відправки' },
                            ].map(opt => (
                                <label
                                    key={opt.id}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: 8,
                                        cursor: 'pointer',
                                        padding: '10px 14px',
                                        border: `2px solid ${payment === opt.id ? '#1a73e8' : '#ccc'}`,
                                        borderRadius: 6,
                                        background: payment === opt.id ? '#eef4ff' : '#fff',
                                        flex: '1 1 180px',
                                        minHeight: 44,
                                        userSelect: 'none',
                                        transition: 'all 0.15s',
                                    }}
                                >
                                    <input
                                        type="radio"
                                        name="paymentMethod"
                                        value={opt.id}
                                        checked={payment === opt.id}
                                        onChange={() => setPayment(opt.id)}
                                        style={{ accentColor: '#1a73e8', marginTop: 2, flexShrink: 0 }}
                                    />
                                    <div>
                                        <div style={{ fontWeight: payment === opt.id ? 600 : 400, fontSize: 15 }}>{opt.label}</div>
                                        <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{opt.desc}</div>
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                    <button type="submit" className="checkout-button" style={{ marginTop: 10 }} disabled={!isFormComplete}>
                        Оформити замовлення
                    </button>
                </form>
                </div>
            </div>

            {/* Sticky CTA для мобільного */}
            {safeItems.length > 0 && (
                <div style={{
                    display: 'none',
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 500,
                    background: '#fff',
                    borderTop: '1px solid #e5e5e5',
                    padding: '10px 16px',
                    boxShadow: '0 -2px 12px rgba(0,0,0,0.1)',
                }} className="checkout-mobile-cta">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: 12, color: '#888' }}>Всього</div>
                            <div style={{ fontWeight: 700, fontSize: 16 }}>{total.toFixed(2)} грн</div>
                        </div>
                        <button
                            type="button"
                            className="checkout-button"
                            style={{ flex: 2, marginTop: 0, padding: '12px 0' }}
                            disabled={!isFormComplete}
                            onClick={() => document.querySelector('form').dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))}
                        >
                            Оформити замовлення
                        </button>
                    </div>
                </div>
            )}
            <Footer />
            {showSuccessModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(0,0,0,0.4)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 2000,
                    padding: '16px',
                    boxSizing: 'border-box',
                }}>
                    <div style={{
                        background: '#fff',
                        borderRadius: 8,
                        padding: '28px 24px',
                        boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
                        maxWidth: payment === 'transfer' ? 460 : 350,
                        width: '100%',
                        textAlign: 'center',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}>
                        <h3 style={{marginBottom: 12}}>Замовлення успішно створено!</h3>
                        {payment === 'transfer' ? (
                            <>
                                <div style={{ marginBottom: 16, color: '#555', fontSize: 14 }}>
                                    Для підтвердження замовлення оплатіть його за реквізитами нижче.<br />
                                    Після оплати ми зв'яжемося з вами.
                                </div>
                                <div style={{
                                    background: '#f9f9f9',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 6,
                                    padding: '14px 16px',
                                    textAlign: 'left',
                                    marginBottom: 20,
                                    fontSize: 14,
                                }}>
                                    {[
                                        { label: 'Отримувач', value: 'ФОП Фігура Тетяна Богданівна' },
                                        { label: 'ЄДРПОУ', value: '2586412525' },
                                        { label: 'IBAN', value: 'UA493052990000026009041032053', mono: true },
                                        { label: 'Банк', value: 'АТ КБ «ПРИВАТБАНК»' },
                                        { label: 'МФО', value: '305299' },
                                    ].map(({ label, value, mono }) => (
                                        <div key={label} style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start',
                                            gap: 12,
                                            padding: '6px 0',
                                            borderBottom: '1px solid #ececec',
                                        }}>
                                            <span style={{ color: '#888', flexShrink: 0 }}>{label}</span>
                                            <span style={{
                                                fontWeight: 600,
                                                fontFamily: mono ? 'monospace' : 'inherit',
                                                fontSize: mono ? 13 : 14,
                                                wordBreak: 'break-all',
                                                textAlign: 'right',
                                            }}>{value}</span>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <div style={{ marginBottom: 24, color: '#555' }}>
                                Ми зв'яжемося з вами найближчим часом.
                            </div>
                        )}
                        <button className="checkout-button" onClick={() => {
                            setShowSuccessModal(false);
                            navigate('/');
                        }} style={{ width: '100%', marginTop: payment === 'transfer' ? 0 : 0 }}>OK</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Checkout; 